module.exports = __webpack_public_path__ + "static/img/tocoupon_qrcode.03ca275.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tocoupon_qrcode.jpg
// module id = 0Ze3
// module chunks = 0